import CalendarPage from "./CalendarPage";

export default function StudentCalendar() {
  return <CalendarPage isAdmin={false} />;
}
